/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import beautify from 'js-beautify';
const js_beautify = beautify.js;

/* eslint-enable import/no-unresolved, import/default */
import './json-configuration.scss';


/*@ngInject*/
export function ApplyJsonConfigurationController($rootScope, $scope, $mdDialog, types, $q, configurationService, type, entities) {

    var vm = this;

    vm.$onInit = function () {
        vm.entities = entities;
        vm.types = types;
        vm.type = type;
        vm.configuration = {};
        vm.cancel = cancel;
        vm.save = save;
        vm.isReadOnly = false;
        vm.loading = false;
    };

    function convertContent(stringContent) {
        var content = {};
        if (stringContent) {
            content = angular.fromJson(stringContent);
        }
        return content;
    }

    function saveConfiguration(type, entities, configuration) {
        vm.loading = true;
        var tasks = [];
        entities.forEach((entity) => {
            tasks.push(configurationService.saveJsonConfiguration(type, entity.id.id, configuration));
        });
        return $q.all(tasks).then(function success() {
            vm.loading = false;
        }, function fail() {
        });
    }


    function save() {
        $scope.$broadcast('form-submit');
        if ($scope.theForm.$valid) {
            vm.configuration.content = convertContent(vm.configurationContent);
            var promise = saveConfiguration(vm.type, vm.entities, vm.configuration);
            promise.then(function success() {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            });
        }
    }

    function cancel() {
        $mdDialog.cancel();
    }

}

/*@ngInject*/
export function ViewJsonConfigurationController($mdDialog, configurationContent) {

    var vm = this;

    vm.$onInit = function () {
        vm.cancel = cancel;
        vm.isReadOnly = true;
        vm.configurationContent = convertContent(configurationContent);
    };

    function convertContent(content) {
        var stringContent = '';
        if (content) {
            stringContent = angular.toJson(content);
            stringContent = js_beautify(stringContent, { indent_size: 4 });
        }
        return stringContent;
    }

    function cancel() {
        $mdDialog.hide();
    }
}


// WEBPACK FOOTER //
// ./src/app/json-configuration/json-configuration.controller.js